import {
  Box,
  Color,
  ThemeColor,
  Image,
  H4,
  Button,
  ButtonVariant,
  ButtonSize,
  IoLogoLinkedin,
  Avatar,
} from 'react-components';
import React, { PropsWithChildren } from 'react';

export interface TeamMemberProps {
  image?: string;
  name: string;
  title: string;
  linkedIn?: string;
  color: Color | ThemeColor;
  invertedTextColor?: boolean;
}

export const TeamMember: React.FunctionComponent<PropsWithChildren<TeamMemberProps>> = ({
  image,
  name,
  title,
  linkedIn,
  color,
  invertedTextColor,
}) => {
  const textColor = invertedTextColor ? 'white' : 'black';
  return (
    <Box position="relative" as="section" bg={image ? undefined : 'indigo'}>
      {image && <Image src={image} width="100%" alt={name} />}
      {!image && <Avatar id={name} size="100%" paddingTop="100%" />}
      <Box
        display="flex"
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        p={3}
        gridGap={3}
        bg={color}
      >
        <Box as="h4" fontSize={2} fontWeight="bold" my={0} color={textColor} flex="1">
          {name}
        </Box>
        <Box color={textColor} flex="1">
          {title.split('\n').map((line, i) => (
            <div key={i}>{line}</div>
          ))}
        </Box>
        {linkedIn && (
          <Box>
            <Button
              as="a"
              href={linkedIn}
              target="_blank"
              variant={invertedTextColor ? ButtonVariant.DEFAULT_INVERSE : ButtonVariant.DEFAULT}
              size={ButtonSize.SMALL}
              width="2rem"
              height="2rem"
              p={2}
            >
              <IoLogoLinkedin size="1rem" />
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};
